<script lang="ts" setup>
import { useWindowSize } from "@vueuse/core";
import animate from "./animate";
import { Motion, Presence } from "motion/vue";

type Props = {
  show: boolean;
};

defineProps<Props>();

const { width } = useWindowSize();
</script>

<template>
  <div
    id="panelWrapper"
    class=" fixed top-0 left-0 w-full z-[1501]"
    :class="show ? 'pointer-events-auto' : 'pointer-events-none'"
  >
    <Presence exitBeforeEnter>
      <Motion
        v-show="show"
        class="panel-layout relative z-20 flex w-full min-h-screen"
        :exit="animate.base.initial"
        :initial="animate.base.initial"
        :animate="animate.base.enter"
      >
        <slot></slot>
      </Motion>
    </Presence>

    <Presence exitBeforeEnter>
      <Motion
        v-show="show"
        class="fixed top-0 left-0 h-screen bg-gray-50 dark:bg-gray-900"
        :exit="animate.background.initial"
        :initial="animate.background.initial"
        :animate="animate.background.enter({ width })"
      />
    </Presence>
  </div>
</template>

<style lang="scss" scoped>
#panelWrapper {
  @import "@/styles/base.scss";
}
@media (max-width: 490px) {
  .panel-layout {
    @apply flex-col items-stretch max-h-screen h-screen;

    & > div {
      @apply w-full max-w-full mx-0;
    }
  }
}

@media (max-width: 900px) {
  .panel-layout {
    & > button {
      @apply hidden;
    }
  }
}
</style>
